<style scoped>
.el-card {
  min-height: 146px;
  margin-top: 5px;
}

.second-card {
  min-height: 102px;
  margin-top: 5px;
  text-align: center;
  color: rgba(0, 0, 0, 0.427450980392157);
}

.second-card-subtext {
  font-size: 26px;
  margin-top: 10px;
  text-align: center;
  color: rgba(0, 0, 0, 0.847058823529412);
}

.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
  box-shadow: none;
}

.primary-card-title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.427450980392157);
  text-align: left;
}

.primary-card-text {
  font-size: 18px;
  text-align: left;
}

.card {
  border: 1px solid #eee;
  padding: 20px;
  text-align: center;
}
</style>
<template>
  <div>

    <el-row>
      <el-col :span="14">
        <p style="font-size: 20px;">{{ pm }}，{{ name }}，祝开心每一天！</p>
        <p style="font-size: 14px;color: rgba(0, 0, 0, 0.427450980392157);margin-top: 25px;">今天，{{ date }}
          {{ week }}，欢迎您回到工作台。</p>
      </el-col>

      <el-col :span="2" style="text-align: center;cursor: pointer">
        <p style="font-size: 14px;color:rgba(0, 0, 0, 0.427450980392157);">到期会员</p>
        <p v-bind:style="homeData.memberEndTimeCount>0?styleRed:styleGray"   @click="$router.push({name:'会员列表',params:{timeType:4,createTimeSearchStart:homeData.createTimeSearchStart,createTimeSearchEnd:homeData.createTimeSearchEnd}})">
          {{ homeData.memberEndTimeCount|defaultFilter }}</p>
      </el-col>

      <el-col :span="2" style="text-align: center;cursor: pointer">
        <p style="font-size: 14px;color:rgba(0, 0, 0, 0.427450980392157);">商品审核</p>
        <p v-bind:style="homeData.goodsCount>0?styleRed:styleGray" @click="$router.push('/home/authPlusGoodsManager')">
          {{ homeData.goodsCount|defaultFilter }}</p>
      </el-col>
      <el-col :span="2" style="text-align: center;cursor: pointer">
        <p style="font-size: 14px;color:rgba(0, 0, 0, 0.427450980392157);">入驻申请</p>
        <p  v-bind:style="homeData.businessAuthCount>0?styleRed:styleGray" @click="$router.push('/home/plusBusinessTabIndex/second')">
          {{ homeData.businessAuthCount|defaultFilter }}</p>
      </el-col>
      <el-col :span="2" style="text-align: center;cursor: pointer">
        <p style="font-size: 14px;color:rgba(0, 0, 0, 0.427450980392157);">商家提现</p>
        <p v-bind:style="homeData.withdrawBusinessCount>0?styleRed:styleGray" @click="$router.push('/home/withdrawRecordList')">
          {{ homeData.withdrawBusinessCount|defaultFilter }}</p>
      </el-col>

      <el-col :span="2" style="text-align: center;cursor: pointer">
        <p style="font-size: 14px;color:rgba(0, 0, 0, 0.427450980392157);">经纪人申请</p>
        <p  v-bind:style="homeData.withdrawCount>0?styleRed:styleGray" @click="$router.push('/home/withdrawalManager')">
          {{ homeData.withdrawCount|defaultFilter }}</p>
      </el-col>
    </el-row>
    <hr/>

      <el-row :gutter="20">

      <el-col :span="6">
        <div class="card">
          <div class="primary-card-title">昨日PV/UV</div>
          <div class="primary-card-text">{{ homeData.yesterdayPv|defaultFilter }} /{{
              homeData.yesterdayUv|defaultFilter
            }}
          </div>
          <hr/>
          <div style="text-align: left">
            <span style="color:rgba(0, 0, 0, 0.427450980392157);">今日PV/UV <span
                style="color: red;">{{ homeData.todayPv|defaultFilter }}/{{
                homeData.todayUv|defaultFilter
              }}</span></span>

          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card">
          <div class="primary-card-title">累计推广用户/会员(个）</div>
          <div class="primary-card-text">{{
              homeData.normalMemberCount|defaultFilter
            }}/{{ homeData.distributorMemberCount|defaultFilter }}
          </div>
          <hr/>
          <div style="text-align: left">

            <span style="color:rgba(0, 0, 0, 0.427450980392157);">今日推广用户/会员 <span
                style="color: red;">{{ homeData.todayNormalMemberCount|defaultFilter }}/{{homeData.todayDistributorMemberCount|defaultFilter}}</span></span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card">
          <div class="primary-card-title">累计招募经纪人/合伙人(个)</div>
          <div class="primary-card-text">{{
              homeData.agentMemberCount|defaultFilter
            }}/{{ homeData.declareMemberCount|defaultFilter }}
          </div>
          <hr/>
          <div style="text-align: left;color:rgba(0, 0, 0, 0.427450980392157);">今日招募经纪人/合伙人
            <span
                style="color: red;">{{ homeData.todayAgentMemberCount|defaultFilter }}/{{
                homeData.todayDeclareMemberCount|defaultFilter
              }}</span></div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card">
          <div class="primary-card-title">累计入驻商户(家)</div>
          <div class="primary-card-text">{{ homeData.businessOnlineCount|defaultFilter }}
          </div>
          <hr/>
          <div style="text-align: left">
            <span style="color:rgba(0, 0, 0, 0.427450980392157);">今日入驻商户  <span
                style="color: red;">{{ homeData.todayBusinessOnlineCount|defaultFilter }}</span></span>
          </div>
        </div>
      </el-col>
      </el-row>
      <el-row style="margin-top: 15px;" :gutter="20">

      <el-col :span="6">
        <div class="card">
          <div class="primary-card-title">平台线上总收入/总收益(元）</div>
          <div class="primary-card-text">￥{{ $math.divide(homeData.platTotalIncome,100)|defaultFilter }}
            /￥{{ $math.divide(homeData.platTotalBonus,100)|defaultFilter }}
          </div>
          <hr/>
          <div style="text-align: left">
            <span style="color:rgba(0, 0, 0, 0.427450980392157);">今日收入/收益   <span
                style="color: red;">￥{{
                $math.divide(homeData.todayPlatTotalIncome,100)|defaultFilter
              }}/￥{{ $math.divide(homeData.todayPlatTotalBonus,100)|defaultFilter }}</span></span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card">
          <div class="primary-card-title">经纪人总收益/累计待提现(元)</div>
          <div class="primary-card-text">￥{{ homeData.profitCount|defaultFilter }}/￥{{$math.subtract($math.bignumber( homeData.profitCount),$math.bignumber(homeData.successWithdrawMoney))}}</div>
          <hr/>
          <div style="text-align: left">
            <span style="color:rgba(0, 0, 0, 0.427450980392157);">今日收益   <span
                style="color: red;">￥{{
                homeData.todayProfitCount|defaultFilter
              }}</span></span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card">
          <div class="primary-card-title">商户实际总收入/累计待提现(元)</div>
          <div class="primary-card-text">￥{{ $math.divide(homeData.businessIncomeMoney,100)|defaultFilter }}/￥{{$math.divide($math.subtract($math.bignumber(homeData.businessIncomeMoney),$math.bignumber(homeData.businessWithdrawMoney)),100)|defaultFilter }}</div>
          <hr/>
          <div style="text-align: left">
            <span style="color:rgba(0, 0, 0, 0.427450980392157);">今日收入  <span
                style="color: red;">￥{{
                $math.divide(homeData.todayBusinessIncomeMoney,100)|defaultFilter
              }}</span></span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card">
          <div class="primary-card-title">加油实付总金额(元）</div>
          <div class="primary-card-text">￥{{ homeData.gasOrderTotalMoney|defaultFilter }}</div>
          <hr/>
          <div style="text-align: left">
            <span style="color:rgba(0, 0, 0, 0.427450980392157);">今日加油实付<span
                style="color: red;">￥{{ homeData.todayGasOrderTotalMoney|defaultFilter }}</span></span>
          </div>
        </div>
      </el-col>
      </el-row>

    <el-row :gutter="10" style="margin-top: 15px;">
      <el-col :span="24">
        <div class="card">
          <div class="Echarts">
            <div id="main2" style="width: 100%;height:400px;margin-top: 50px;"></div>
          </div>
        </div>
      </el-col>

    </el-row>
    <el-row :gutter="20" style="margin-top: 15px;">
      <el-col :span="12">
        <div class="card">
          <div class="Echarts">
            <div id="main" style="width: 100%;height:400px;"></div>
          </div>
        </div>
      </el-col>

      <el-col :span="12">
        <div class="card">
          <div class="Echarts">
            <div id="main1" style="width: 100%;height:400px;"></div>
          </div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import echarts from 'echarts'
import distributor from '@/framework/models/distributor'
import BasicPager from '@/mixins/BasicPager'
import usedCarModel from '@/framework/models/usedCarModel'

export default {
  extends: BasicPager,
  name: 'vip-card-home',
  data () {
    return {
      profitTop: null,
      date: null,
      pm: null,
      week: null,
      name: null,
      styleRed: {
        color: 'red',
        fontSize: '30px'
      },
      styleGray: {
        color: 'gray',
        fontSize: '30px'
      },
      homeData: {
        todayPv: 0,
        todayUv: 0,
        yesterdayPv: 0,
        yesterdayUv: 0,
        businessOnlineCount: 0,
        todayBusinessOnlineCount: 0,
        distributorMemberCount: 0,
        normalMemberCount: 0,
        todayDistributorMemberCount: 0,
        todayNormalMemberCount: 0,
        declareMemberCount: 0,
        todayDeclareMemberCount: 0,
        todayAgentMemberCount: 0,
        agentMemberCount: 0,
        platTotalIncome: 0,
        todayPlatTotalIncome: 0,
        platTotalBonus: 0,
        todayPlatTotalBonus: 0,
        todayProfitCount: 0,
        profitCount: 0,
        successWithdrawMoney: 0,
        todaySuccessWithdrawMoney: 0,
        businessIncomeMoney: 0,
        todayBusinessIncomeMoney: 0,
        businessWithdrawMoney: 0,
        todayGasOrderTotalMoney: 0,
        gasOrderTotalMoney: 0,
        createTimeSearchStart:null,
        createTimeSearchEnd:null
      }
    }
  },
  mounted () {
    this.name = this.loginInfo.channelPageName
    this.week = this.getWeek()
    this.date = this.getDate()
    this.pm = this.getPm()
    this.loadDataInfo()
    this.loadPvUvData()
  },
  methods: {

    getPm () {
      let str = ''
      let now = new Date()
      let hour = now.getHours()
      if (hour < 6) {
        str = '凌晨好'
      } else if (hour < 9) {
        str = '早上好'
      } else if (hour < 12) {
        str = '上午好'
      } else if (hour < 14) {
        str = '中午好'
      } else if (hour < 17) {
        str = '下午好'
      } else if (hour < 19) {
        str = '傍晚好'
      } else if (hour < 22) {
        str = '晚上好'
      } else {
        str = '夜里好'
      }
      return str
    },
    getDate () {
      let unixtime = new Date().getTime()

      let localeDate = new Date(unixtime)
      let year = localeDate.getFullYear()
      let month = localeDate.getMonth() + 1
      let day = localeDate.getDate()
      let dateText = year + '年' + (month < 10 ? '0' + month : month) + '月' + (day < 10 ? '0' + day : day) + '日'
      return dateText
    },
    getWeek () {
      let str = ''
      let week = new Date().getDay()
      if (week === 0) {
        str = '星期日'
      } else if (week === 1) {
        str = '星期一'
      } else if (week === 2) {
        str = '星期二'
      } else if (week === 3) {
        str = '星期三'
      } else if (week === 4) {
        str = '星期四'
      } else if (week === 5) {
        str = '星期五'
      } else if (week === 6) {
        str = '星期六'
      }
      return str
    },

    loadDataInfo () {
      let _this = this
      let params = {
        channelId: this.loginInfo.id
      }
      if (localStorage.userInfo && localStorage.userInfo.roleName === '省心车服') {
        params.adminRoleType = 1
      } else {
        params.adminRoleType = 2
      }
      let listener = {
        success (dataInfo) {
          let datas = dataInfo.datas
          _this.homeData = datas
          // 图表
          let allMemberDataList = datas.allMemberDataList
          let date = []
          let data = []
          for (let i = 0; i < allMemberDataList.length; i++) {
            let item = allMemberDataList[i]
            date.push(item.returnDate)
            data.push(item.countData)
          }

          let memberDataList = datas.memberDataList
          let date1 = []
          let data1 = []
          for (let i = 0; i < memberDataList.length; i++) {
            let item = memberDataList[i]
            date1.push(item.returnDate)
            data1.push(item.countData)
          }

          let orderDataList = datas.orderDataList
          let date2 = []
          let data2 = []
          for (let i = 0; i < orderDataList.length; i++) {
            let item = orderDataList[i]
            date2.push(item.returnDate)

            data2.push(item.countData)
          }

          let statistics = {
            date: date,
            data: data,
            date1: date1,
            data1: data1,
            date2: date2,
            data2: data2
          }
          _this.myEcharts(statistics)
        }
      }

      distributor.getDistributorIndex(_this, params, listener)
    },
    loadPvUvData () {
      // pv uv
      let _this = this
      let id = null
      if (this.loginInfo.loginPath === 'channel') {
        id = this.loginInfo.id
      }

      let params1 = {
        id: id
      }

      let listener1 = {
        success (dataInfo) {
          let datas = dataInfo.datas

          _this.myEcharts(datas)
        }
      }

      usedCarModel.getPriveteUsedCarIndex(_this, params1, listener1)
    },
    myEcharts (statistics) {
      // 基于准备好的dom，初始化echarts实例
      if (statistics.data) {
        var myChart = echarts.init(document.getElementById('main'))
        var myChart1 = echarts.init(document.getElementById('main1'))
        // 指定图表的配置项和数据
        let option = {
          title: {
            text: '近30天用户/会员增长趋势'
          },
          xAxis: {
            type: 'category',
            data: statistics.date
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '用户',
            color: '#1890ff',
            data: statistics.data,
            type: 'line',
            smooth: true,
            lineStyle: {
              width: 3
            },
            areaStyle: {
              color: '#e8f4ff'
            }
          },
          {
            name: '会员',
            color: '#f4c77f',
            data: statistics.data1,
            type: 'line',
            smooth: true,
            lineStyle: {
              width: 3
            },
            areaStyle: {
              color: '#e8f4ff'
            }
          }
          ]
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)

        // 指定图表的配置项和数据
        let option1 = {
          title: {
            text: '近30天线上总收入增长趋势'
          },
          xAxis: {
            type: 'category',
            data: statistics.date
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '线上总收入',
              color: '#6a7985',
              data: statistics.data2,
              type: 'line',
              smooth: true,
              lineStyle: {
                width: 3
              },
              areaStyle: {
                color: '#e8f4ff'
              }
            }
          ]
        }

        myChart1.setOption(option1)
      }
      if (statistics.pv) {
        let myChart2 = echarts.init(document.getElementById('main2'))

        // 指定图表的配置项和数据
        let option2 = {
          title: {
            text: '近30天PV/UV数据趋势'
          },
          xAxis: {
            type: 'category',
            data: statistics.pv.dateResult
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            name: 'PV',
            color: '#1890ff',
            data: statistics.pv.countResult[0],
            type: 'line',
            smooth: true,
            lineStyle: {
              width: 3
            },
            areaStyle: {
              color: '#e8f4ff'
            }
          }, {
            name: 'UV',
            color: '#f4c77f',
            data: statistics.uv.countResult[0],
            type: 'line',
            smooth: true,
            lineStyle: {
              width: 3
            },
            areaStyle: {
              color: '#e8f4ff'
            }
          }]
        }
        myChart2.setOption(option2)
      }
    }
  }
}
</script>
